import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";

/**
 * Generated class for the FlagsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "flags",
})
@Component({
  selector: "page-flags",
  templateUrl: "flags.html",
})
export class FlagsPage {
  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  flags = this.evaluateFlags();

  panic() {
    while (true) {
      throw new Error("panic");
    }
  }

  evaluateFlags() {
    const result = {};
    ["auto-activate", "debugging"].forEach((key) => {
      result[key] = localStorage["flag-" + key] === "true";
    });
    return result;
  }

  updateFlag(flagName) {
    if (this.flags[flagName]) {
      delete localStorage["flag-" + flagName];
    } else {
      localStorage["flag-" + flagName] = "true";
    }

    this.flags = this.evaluateFlags();
  }
}



// WEBPACK FOOTER //
// ./src/pages/flags/flags.ts